<template>
  <div id="">
    <section class="bannerprincipal pb-2">
      <SiteNav v-if="rolRegistro == true"></SiteNav>
      <SiteNav2 v-if="rolRegistro == false"></SiteNav2>
      <div class="col-12 text-center py-3">
        <div class="row"></div>
      </div>
    </section>

    <div class="container-fluid">
      <!-- <div class="row pb-5">
        <div class="col-12 blockd fG amarillo">Semana 1</div>
      </div>-->
      <!-- <div class="row">
        <div class="col-12 py-5"></div>
      </div> -->

      <div class="row pt-5">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <div class="text-center my-5">
                <p class="fXG amarillo" v-if="rolRegistro == true">
                  Registro de asistencia
                </p>
                <p class="fXG amarillo" v-else>Consulta</p>
                <p class="negro" v-if="user != null">
                  Usuario: <span class="amarillo">{{ user.nombre }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-6 offset-md-3" v-if="this.registro == null">
            <form @submit="buscaXCodigo($event)" class="pb-3 r15">
              <div class="col-12 text-left pb-4 fG">
                <span class="">Buscar por código de invitación:</span>
              </div>
              <div class="col-12">
                <div class="row pb-4">
                  <div class="col-lg-12 pb-0">
                    <!-- <div class="negro fG">Nombre</div> -->
                    <input
                      v-model.trim="signupForm.codigo"
                      type="text"
                      @input="
                        signupForm.codigo = $event.target.value.toUpperCase();
                        signupForm.codigo = quitarAcentos(signupForm.codigo);
                      "
                      placeholder="Código de invitación*"
                      required
                    />
                  </div>

                  <div class="row pb-5">
                    <div class="col-12 text-center">
                      <button
                        v-if="rolRegistro == true"
                        type="submit"
                        class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                      >
                        BUSCAR Y REGISTRAR
                      </button>
                      <button
                        v-else
                        type="submit"
                        class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                      >
                        BUSCAR
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="row" v-if="this.registro == null">
            <div class="col-md-6 offset-md-3">
              <form @submit="signup($event)" class="py-2 r15">
                <div class="col-12 text-left pb-4 fG">
                  <span class="">Buscar por correo:</span>
                </div>
                <div class="col-12">
                  <div class="row pb-4">
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="negro fG">Nombre</div> -->
                      <input
                        v-model.trim="signupForm.email"
                        type="email"
                        placeholder="Email*"
                        required
                      />
                    </div>

                    <div class="row pb-5">
                      <div class="col-12 text-center">
                        <button
                          v-if="rolRegistro == true"
                          type="submit"
                          class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                        >
                          BUSCAR Y REGISTRAR
                        </button>
                        <button
                          v-else
                          type="submit"
                          class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                        >
                          BUSCAR
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="col-md-6 offset-md-3">
              <form @submit="buscaCelular($event)" class="pb-3 r15">
                <div class="col-12 text-left pb-4 fG">
                  <span class="">Buscar por celular:</span>
                </div>
                <div class="col-12">
                  <div class="row pb-4">
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="negro fG">Nombre</div> -->
                      <input
                        v-model.trim="signupForm.celular"
                        type="number"
                        placeholder="Celular*"
                        required
                      />
                    </div>

                    <div class="row pb-5">
                      <div class="col-12 text-center">
                        <button
                          v-if="rolRegistro == true"
                          type="submit"
                          class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                        >
                          BUSCAR Y REGISTRAR
                        </button>
                        <button
                          v-else
                          type="submit"
                          class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                        >
                          BUSCAR
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="col-md-6 offset-md-3" v-if="rolRegistro == false">
              <form @submit="buscaApellido($event)" class="pb-3 r15">
                <div class="col-12 text-left pb-4 fG">
                  <span class="">Buscar por apellido paterno:</span>
                </div>
                <div class="col-12">
                  <div class="row pb-4">
                    <div class="col-lg-12 pb-0">
                      <!-- <div class="negro fG">Nombre</div> -->
                      <input
                        v-model.trim="signupForm.apellido_paterno"
                        type="text"
                        placeholder="Apellido Paterno*"
                        required
                      />
                    </div>

                    <div class="row pb-5">
                      <div class="col-12 text-center">
                        <button
                          type="submit"
                          class="pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto"
                        >
                          BUSCAR
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div
            class="row bgblanco pt-5"
            v-if="registro != null && registroExitoso == true"
          >
            <!-- <div class="col-12">
              <div class="row pb-5">
                <div class="col-12 text-center">
                  <a
                    @click="registrarAsistencia($event)"
                    class="btnaction pointer"
                    >Registrar Asistencia</a
                  >
                </div>
              </div>
            </div> -->

            <div class="col-12 text-center">
              <p class="fXG morado" v-if="rolRegistro == true">
                Se ha completado el registro exitosamente.
              </p>
              <p class="fXG morado" v-else>
                Mostrando información (sólo consulta).
              </p>
            </div>
          </div>

          <div class="row bgblanco" v-if="registro != null">
            <div
              class="col-12 round bg-white pt-4"
              v-for="(reg, index) in registro"
              :key="index"
            >
              <div class="row">
                <div class="col-md-6 offset-md-3 pb-5">
                  <p class="text-center" v-if="rolRegistro == false">
                    <img
                      class="qr"
                      :src="
                        'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=' +
                        registro.codigo_qr
                      "
                      alt="qr"
                    />
                  </p>
                  <p
                    class="fXG bold text-center pb-5"
                    v-if="rolRegistro == false"
                  >
                    {{ reg.codigo_qr }}
                  </p>
                  <p class="negro bold fG text-center">
                    <span v-if="reg.nombre_1 != ''">{{ reg.nombre }} </span>

                    <span v-if="reg.apellido_paterno != ''"
                      >{{ reg.apellido_paterno }}
                    </span>
                    <span v-if="reg.apellido_materno != ''"
                      >{{ reg.apellido_materno }}
                    </span>
                  </p>
                  <p class="negro bold fG text-center">
                    {{ reg.email }}
                  </p>
                  <hr class="mb-4" />

                  <div class="pb-3 negro row">
                    <div class="col-5 offset-1">Tipo</div>
                    <div class="col-5 text-right">
                      {{ reg.tipo }}
                    </div>
                  </div>
                  <hr class="mb-4" />

                  <div class="pb-3 negro row">
                    <div class="col-5 offset-1">Empresa</div>
                    <div class="col-5 text-right">
                      {{ reg.empresa }}
                    </div>
                  </div>
                  <hr class="mb-4" />

                  <div class="pb-3 negro row">
                    <div class="col-5 offset-1">Puesto</div>
                    <div class="col-5 text-right">
                      {{ reg.puesto }}
                    </div>
                  </div>
                  <hr class="mb-4" />

                  <div class="pb-3 negro row">
                    <div class="col-5 offset-1">Pulsera</div>
                    <div class="col-5 text-right">
                      {{ reg.pulsera }}
                    </div>
                  </div>
                  <hr class="mb-4" />


                  <div class="row" v-if="rolRegistro == true">
                    <div class="col-12 text-center">
                      <a
                        :href="'./lector/impresion/' + reg.email"
                        target="_blank"
                        class="btnaction pointer"
                      >
                        Imprimir gafete
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
            </div>

            <div class="col-12">
              <div class="row py-5">
                <div class="col-12 text-center">
                  <a @click="escanearNuevo($event)" class="btnaction pointer"
                    >Buscar otro usuario</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
      <div class="row">
        <div class="col-12 py-5"></div>
      </div>
    </div>

    <Footer></Footer>
    <!-- <Glyphicons></Glyphicons> -->
  </div>
</template>


<script>
const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 42;
import Footer from "@/components/Footer";
// import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SiteNav from "@/components/SiteNavLector";
import SiteNav2 from "@/components/SiteNavLectorSoloLectura";

import * as moment from "moment";

import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    Footer,
    SiteNav,
    SiteNav2
    // Glyphicons,
  },
  data() {
    return {
      reenvioForm: {
        codigo: "",
      },

      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        email: "",
        celular: "",
        codigo: "",
        apellido_paterno: "",
      },
      formAsistencia: {},

      columnsRegistros: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email_user",
        "codigo_pais",
        "telefono",
        "movil",
        "torneo",
        "handicap",
        "talla_tops",
        "clinica",
        "talla_guantes",
        "talla_cubrebocas",
        "terminos",
      ],
      columnsInvitados: [
        "codigo",
        "nombre_1",
        "nombre_2",
        "apellido_paterno",
        "apellido_materno",
        "empresa",
        "puesto",
        "email_user",
        "codigo_pais",
        "telefono",
        "movil",
      ],
      columnsSolicitudes: [
        "no_cliente",
        "nombre",
        "apellido",
        "email",
        "estado",
        "FechaRegistro",
      ],
      data: null,
      options: {
        perPage: 100,
        editableColumns: [],
        sortable: [],
      },

      data_users: null,
      options_users: {
        perPage: 100,
        headings: {
          user_id: "UID",
          nombre: "Nombre",
          apellido: "Apellido",
          email: "Email",
          tel: "Tel",
          fecha_nacimiento: "Fec. Nac.",
          edad: "Edad",
          suma_puntos: "Suma Puntos",
          suma_time: "Suma Segundos",
          suma_time_txt: "Tiempo Total",
          num_tickets: "Número de Tickets",
          created_on: "Fecha de Registro",
          dia_registro: "Día de Registro",
        },
        editableColumns: [],
        sortable: [],
      },
      tickets: [],
      tickets_procesados: [],
      users: {},
      users_array: [],
      users_auth: [],
      centros: [],
      registro: null,
      invitados: [],
      user: null,
      registroExitoso: false,
      rolRegistro: false,
      soloConsulta: [
        "lector1",
        "lector2",
        "lector3",
        "lector4",
        "lector5",
        "lector6",
        "lector7",
        "lector8"
      ],
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.user = JSON.parse(localStorage.getItem("user_foroprosa_2023_lector"));

    if (!this.soloConsulta.includes(this.user.nombre)) {
      this.rolRegistro = true;
    }
  },
  methods: {
    getInvitados() {
      console.log("get invitados");

      const https = require("https");
      var qData = {
        // id: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getInvitados.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.invitados = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    getRegistros() {
      console.log("get registros");

      const https = require("https");
      var qData = {
        no_cliente: this.user.no_cliente,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistros.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registros = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              //this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1;
              this.signupForm.nombre_2 = res.datos[0].nombre_2;
              this.signupForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.signupForm.apellido_materno = res.datos[0].apellido_materno;
              this.signupForm.empresa = res.datos[0].empresa;
              this.signupForm.puesto = res.datos[0].puesto;
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.buscaEmail();
    },
    async buscaEmail() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");

      this.signup;
      var qData = this.signupForm;
      qData.id_operador_asistio = this.user.id;
      qData.rol_registro = this.rolRegistro;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistroXEmail.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            this.$store.dispatch("showLoader", false);
            console.log("res registro x email");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registro = res.datos;
              this.registroExitoso = true;
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    async buscaCelular(e) {
      e.preventDefault();
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;
      qData.id_operador_asistio = this.user.id;
      qData.rol_registro = this.rolRegistro;
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistroXCelular.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            this.$store.dispatch("showLoader", false);
            console.log("res registro x email");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registro = res.datos;
              this.registroExitoso = true;
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    async buscaApellido(e) {
      e.preventDefault();
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;
      qData.id_operador_asistio = this.user.id;
      qData.rol_registro = this.rolRegistro;
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getXApellido.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            this.$store.dispatch("showLoader", false);
            console.log("res registro x email");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registro = res.datos;
              this.registroExitoso = true;
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    async buscaXCodigo(e) {
      e.preventDefault();
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;
      qData.id_operador_asistio = this.user.id;
      qData.rol_registro = this.rolRegistro;
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistroXCodigo.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            this.$store.dispatch("showLoader", false);
            console.log("res registro x email");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registro = res.datos;
              this.registroExitoso = true;
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    resetForm() {
      this.signupForm = {
        email: "",
        celular: "",
        codigo: "",
        apellido_paterno: "",
      };
    },
    async onDecode(decodedString) {
      console.log(decodedString);

      this.getRegistro(decodedString);
    },
    getRegistro(decodedString) {
      console.log("get registro");

      const https = require("https");
      var qData = {
        codigos: decodedString,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "getRegistro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registro = res.datos;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    registrarAsistencia(e) {
      console.log("registra asistencia");

      this.$store.dispatch("showLoader", true);
      const https = require("https");
      var qData = this.formAsistencia;
      qData.id = this.registro.id;
      qData.codigo = this.registro.codigo_qr;
      qData.id_operador_asistio = this.user.id;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registrarAsistencia.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.registroExitoso = true;
              swal
                .fire({
                  title: "Bien",
                  html: res.msg,
                  icon: "success",
                  confirmButtonText: "Ok",
                })
                .then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                });
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    escanearNuevo(e) {
      this.registro = null;
      this.signupForm.email = "";
    },
  },
};
</script>

